import { type Repub } from '@cx-modules/constants';

export * from './constants';
export * from './types';
export * from './utils';

export function logout(repub: Repub, redirectUrl: string): void {
  const options = {
    method: 'POST',
    headers: {
      'OC-Repub': repub,
      'Content-Type': 'application/json',
    },
    credentials: 'include' as RequestCredentials,
  };

  fetch('/api/cx/myoc/v2/logout', options).finally(() => {
    window.location.href = redirectUrl;
  });
}
